export const LEARN_MORE_CLICKED_KEY = 'learn_more_clicked_for_product_id';
export const ADD_TO_CART_CLICKED_KEYS = 'add_to_cart_clicked_for_product_id_array';
